<div class="host" [class.edicao]="modoEdicao" [attr.data-identificador]="item.identificador">
  <div class="host-cab" [attr.title]="modoEdicao ? 'Arraste para mover' : null" (pointerdown)="aoPressionarCabecalho($event)">
    @if (modoEdicao) {
      <span class="alca"><i class="pi pi-arrows-alt"></i></span>
    }
    <i class="icone" [ngClass]="item.icone || 'pi pi-th-large'"></i>
    <span class="nome" [title]="titulo">{{ titulo }}</span>
    @if (configuravel) {
      <p-button icon="pi pi-sliders-h" [rounded]="true" [text]="true" severity="secondary" size="small" ariaLabel="Configurar widget"
        pTooltip="Configurar" styleClass="configurar" (onClick)="configurar()" />
    }
    @if (modoEdicao) {
      <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" size="small" ariaLabel="Remover"
        pTooltip="Remover" styleClass="remover" (onClick)="remover.emit()" />
    }
  </div>

  <div class="host-corpo">
    <ng-container #alvo />

    @if (indisponivel || falhaCarregamento) {
      <div class="indisponivel">
        <i class="pi pi-ban"></i>
        <strong>Widget indisponível</strong>
        <code>{{ item.identificador }}</code>
        @if (falhaCarregamento) {
          <p-button label="Tentar novamente" [text]="true" size="small" (onClick)="criar()" />
        }
      </div>
    }
  </div>
</div>
